
export class StringUtils {

  public static trimToNull(parameter: string): string | null {

    if (StringUtils.isEmpty(parameter) || parameter === 'null') {
      return null;
    }
    return parameter;
  }

  public static isEmpty(parameter: string): boolean {
    return parameter == null || parameter === undefined || parameter === '';
  }
}
